import { Component } from '@angular/core';

export class objectHelper{

/*
  * Function Name: MatchDataKeyNames
  * Author: Asser Maany Date: 9 Nov 2023
  * Description: Change keys of sourceList to match the case of matchingKeys object.
  * Paramters: sourceList --> List of objects to change their keys to match case of matchingKeys
  *            matchingKeys --> List of keys that will be used in matching
  *            Return Value --> New list with keys matching the keys of matchingKeys input paramter
  * example:
  * sourceList: 
    const sourceList:{PaymentTerm: string , Buid:string , TermsBranch:string} [] = 
    [
      {PaymentTerm: "Term1" , Buid:"1", TermsBranch:"NA"},
      {PaymentTerm: "Term2" , Buid:"2", TermsBranch:"NA"},
      {PaymentTerm: "Term3" , Buid:"3", TermsBranch:"NA"},

    ];
  * matchingKeys:
    const matchingKeys:{ PaymentTerm: string,BUID:string,OtherKey:number}=
              {PaymentTerm:"PaymentTerm" , BUID:"3",OtherKey:5};
  * Return Values:
              [
    {
        "PaymentTerm": "Term1",
        "BUID": "1",
        "TermsBranch": "NA"
    },
    {
        "PaymentTerm": "Term2",
        "BUID": "2",
        "TermsBranch": "NA"
    },
    {
        "PaymentTerm": "Term3",
        "BUID": "3",
        "TermsBranch": "NA"
    }
]
  * Notice: key Buid, changed to BUID
  */
static MatchDataKeyNames(sourceList: any[] , matchingKeys: any)//:any
{
  let Originalkey:string="";
  let matchingKey:any="";
  let newKeys:any={};
  if (sourceList)
  {
      if (sourceList[0])
      {
        
        Object.keys(sourceList[0]).forEach(key=> {
              //Search for matching object in MatchformGroup
              Originalkey=key;
              matchingKey= Object.keys(matchingKeys).find(MatchKey =>
                MatchKey.toLowerCase() === key.toLowerCase() )

              if (Originalkey && matchingKey && (Originalkey != matchingKey))
              {
                 newKeys[Originalkey] = matchingKey;
              }
        })

      }
      if (newKeys && (Object.keys(newKeys).length >0) )
        {
        return sourceList.map( rec => {
          return this.renameKeys(rec ,newKeys ) }
          );
        
        this.renameKeys(sourceList[0] ,newKeys )
        }
      else
        return sourceList

  }
  else
  return sourceList;


}

/*
  * Function Name: renameKeys
  * Author: Asser Maany Date: 9 Nov 2023
  * Description: Returns object with same list of keys, but with key names renamed from input list newKeys.
  * Paramters: obj --> Object with keys to rename
  *            newKeys --> List of keys to rename, with key as the old key to rename and value is the new key name
  * example:
  * obj: 
        {PaymentTerm: "Term1" , Buid:"1", TermsBranch:"NA"}
  * newKeys:
        {Buid:'BUID'}
  * Return Values:
        {PaymentTerm: "Term1" , BUID:"1", TermsBranch:"NA"}
  * Notice: key Buid, changed to BUID
  */
static  renameKeys(obj:any, newKeys:any):any {
  const entries = Object.keys(obj).map(key => {
    const newKey = newKeys[key] || key;

    return {[newKey]: obj[key]};
  });

  return Object.assign({}, ...entries);
}

/*
  * Function Name: getCaseInsensitiveKeyValue
  * Author: Asser Maany Date: 9 Nov 2023
  * Description: Get value from object provided key name case insensitive (regardless of how the key capitalizaiton is set).
  * Paramters: obj --> Object to get its key value
  *            keyToFind --> key to get the value of, provided that key can be given by any capitalization
  * example:
  * obj: 
        {PaymentTerm: "Term1" , Buid:"1", TermsBranch:"NA"}
  * key:
        'BUiD'
  * Return Values:
        '1'
  * Notice: key in object is Buid and we are searching by key BUiD, typically type script is case sensetive
        and will not return the value of the key, this funciton provides case insensetive key matching
  */

static  getCaseInsensitiveKeyValue(obj:any,keyToFind:string):any
{
  if ((obj !== null) && (obj !== undefined) && (keyToFind !== null) && (keyToFind !== undefined))
  {
    const keys = Object.keys(obj);
    const lowerCaseKeyToFind = keyToFind.toLowerCase();

    for (const key of keys) {
      if (key.toLowerCase() === lowerCaseKeyToFind) {
        return obj[key];
      }
    }
  }

  return undefined; // Key not found
}




}